import type { ApiResponse } from "@/types/common";
import type {
  BackupFileDto,
  BackupOverviewDto,
  BackupSettingsDto,
  BackupSettingsUpdateDto,
} from "@/types/backup.dto";
import { apiClient, unwrapApiResponse } from "./httpClient";

export const backupService = {
  getOverview(): Promise<BackupOverviewDto> {
    return unwrapApiResponse(apiClient.get<ApiResponse<BackupOverviewDto>>("/Backups"));
  },

  updateSettings(dto: BackupSettingsUpdateDto): Promise<BackupSettingsDto> {
    return unwrapApiResponse(apiClient.put<ApiResponse<BackupSettingsDto>>("/Backups/settings", dto));
  },

  /** Creates a backup and waits for it to finish (can take a while on a large database). */
  create(): Promise<BackupFileDto> {
    return unwrapApiResponse(
      apiClient.post<ApiResponse<BackupFileDto>>("/Backups", undefined, { timeout: 35 * 60 * 1000 }),
    );
  },

  remove(fileName: string): Promise<boolean> {
    return unwrapApiResponse(apiClient.delete<ApiResponse<boolean>>(`/Backups/${encodeURIComponent(fileName)}`));
  },

  /** Downloads through the API client so the auth header is sent, then hands the file to the browser. */
  async download(fileName: string): Promise<void> {
    const response = await apiClient.get<Blob>(`/Backups/${encodeURIComponent(fileName)}/download`, {
      responseType: "blob",
      timeout: 35 * 60 * 1000,
    });
    const url = URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  },
};
